import * as CONST from 'Reducers/PickupTimes/const'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import { find } from 'lodash'

const moment = extendMoment(Moment)

export const validate = (values, props) => {
  const errors = {}
  const { pickupTimesList } = props

  const currentPickupRange = moment.range([
    moment(values.timeStart),
    moment(values.timeStop),
  ])
  const currentDay = values.day

  if (moment(values.timeStart).isAfter(moment(values.timeStop))) {
    errors.timeStart = 'Invalid date range'
  }

  if (moment(values.timeStop).isBefore(moment(values.timeStart))) {
    errors.timeStop = 'Invalid date range'
  }

  // Is current time overlapping any of existing pickup times by the given day
  pickupTimesList.forEach(pickupTime => {
    const pickupTimeRange = moment.range([
      moment(pickupTime.timeStart, CONST.TIME_FORMATS.HOURS_MINUTES),
      moment(pickupTime.timeStop, CONST.TIME_FORMATS.HOURS_MINUTES),
    ])
    const day = find(CONST.DAYS_OF_THE_WEEK, { label: pickupTime.day }).value

    if (currentPickupRange.overlaps(pickupTimeRange) && currentDay === day) {
      errors.timeStop = 'Current date range overlaps existing one'
    }
  })

  return errors
}
